<div
    class="cashoutPopup"
    *ngIf="player.isPlayerRequesting && gameTableService.gameTable.CashedOutPopUp && player.cashedOutAmount > 0"
    [ngClass]="{ 'cashout-max': maxSeats >= 7 }">
    {{ content?.CashoutMessage }} : &nbsp;${{ (player.cashedOutAmount / 100).toLocaleString() }}
</div>
<div
    class="player-seat-container"
    [style.left]="player.position.getXAxis()"
    [style.top]="player.position.getYAxis()"
    [class.selfPlayer]="player.isPlayerRequesting">
    <div
        ngClass="{{ player.transformPosition }}"
        class="chips-reduced"
        *ngIf="
            gameTableService.gameTable.isReplayerV3 &&
            gameTableService.gameTable.isReducedChipsEnabled &&
            gameTableService.gameTable.isCashReducedActionCalled &&
            player.isReduceChipshappened
        ">
        <span>{{ content?.BalanceReductionMessage }}</span>
    </div>
    <div class="player-seat">
        <div class="cashout-block">
            <div
                ngClass="{{ player.transformPosition }}"
                class="cashout-icon"
                *ngIf="gameTableService.gameTable.CashedOutPopUp && player.cashedOutAmount > 0"></div>
        </div>
        <div ngClass="{{ getStatus() }}" class="player-events" *ngIf="player.event">
            <span>{{ getStatus() }}</span>
        </div>
        <div ngClass="{{ player.transformPosition }}" class="player" [class.optionSet]="player.OptionSet">
            <div class="player-border"></div>
        </div>

        <div ngClass="{{ player.transformPosition }}" class="seat" [class.fold]="player.event">
            <div
                ngClass="{{ player.transformPosition }}"
                class="chips-reduced-landscape"
                *ngIf="
                    !gameTableService.gameTable.isReplayerV3 &&
                    gameTableService.gameTable.isReducedChipsEnabled &&
                    gameTableService.gameTable.isCashReducedActionCalled &&
                    player.isReduceChipshappened
                "></div>
            <div class="seat-info">
                <p
                    class="name"
                    *ngIf="!gameTableService.gameTable.isReplayerV3"
                    [class.fold]="player.event && !serve.isMobile"
                    [class.truncated]="player.isPlayerNameTruncated">
                    <span *ngIf="!player.event || serve.isMobile">{{ player.name }}</span
                    ><span *ngIf="player.event && !serve.isMobile">{{ getStatus() }}</span>
                </p>
                <p
                    class="name"
                    *ngIf="gameTableService.gameTable.isReplayerV3"
                    [class.fold]="player.event"
                    [class.truncated]="player.isPlayerNameTruncated">
                    <span>{{ player.name }}</span>
                    <span ngClass="{{ getStatus() }}" class="eventBtn" *ngIf="player.event && !serve.isMobile && !player.isPlayerAllIn">{{
                        getStatus()
                    }}</span>
                </p>
                <div *ngIf="!isMobile; else mobilePlayerPotHTML">
                    <p class="balance">
                        <span *ngIf="!player.isPlayerAllIn">
                            <span *ngIf="!player.isTourny">{{ player.currencyType }}</span>
                            <span *ngIf="!player.isTourny">{{
                                (player.chips.value / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })
                            }}</span>
                            <span *ngIf="player.isTourny">{{ (player.chips.value / 100).toLocaleString() }}</span>
                        </span>
                        <span class="all-in-flag" *ngIf="player.isPlayerAllIn"> {{ allInText }}</span>
                    </p>
                </div>
                <ng-template #mobilePlayerPotHTML>
                    <p class="balance" [hidden]="formatChange()">
                        <span *ngIf="!player.isPlayerAllIn">
                            <span *ngIf="!player.isTourny">{{ player.currencyType }}</span>
                            <span *ngIf="!player.isTourny">{{ amount }}</span>
                            <span *ngIf="player.isTourny">{{ amount }}</span>
                        </span>
                        <span *ngIf="player.isPlayerAllIn"> {{ allInText }}</span>
                    </p>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<div
    ngClass="{{ player.transformPosition }}"
    class="hold-cards"
    [class.selfPlayer]="player.isPlayerRequesting"
    [class.displayCards]="!player.displayCards"
    [class.requestedPlayerFolded]="player.isSelfPlayerfolded"
    [class.closedCards]="!player.isPlayerCardsOpened"
    [class.sevenCards]="player.sevenCardStud"
    [class.omaha]="player.Omahagame"
    [style.left]="getxaxis()">
    <pkr-card
        *ngFor="let card of player.cards; let i = index"
        [card]="card"
        [index]="i"
        [seq]="getHoleCardsSequence(i)"
        [topValue]="player.position.getYAxis()"
        [leftValue]="player.position.getXAxis()"></pkr-card>
</div>
